import { SERVER_URL } from '../../../utils/apiUtilsConstants';

const VARIABLE_REGEX = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;
export const DEFAULT_PLAYGROUND_VALUES = {
  seoGuidelines: '',
};

/**
 * Fetch available variables for a prompt from the backend.
 * The backend reads variables from the prompt definition files.
 */
export const fetchAvailableVariables = async (category, name) => {
  if (!category) return [];
  
  try {
    const params = new URLSearchParams({ category });
    if (name) params.append('name', name);
    
    const response = await fetch(
      `${SERVER_URL}/api/ui/bo/llm/prompts/variables/lookup?${params}`,
      { method: 'GET', credentials: 'include' }
    );
    
    if (response.ok) {
      const data = await response.json();
      return data.variables || [];
    }
    
    console.warn('Failed to fetch variables for', category, name);
    return [];
  } catch (err) {
    console.error('Error fetching available variables:', err);
    return [];
  }
};

export const extractVariablesFromTemplate = (templateText) => {
  if (!templateText) return [];
  const matches = new Set();
  let m;
   
  while ((m = VARIABLE_REGEX.exec(templateText)) !== null) {
    if (m[1]) matches.add(m[1]);
  }
  return Array.from(matches);
};

export const applyVariablesToTemplate = (template, variables) => {
  if (!template) return '';
  let output = template;
  Object.keys(variables).forEach((v) => {
    const placeholderRegex = new RegExp(`\\{\\{\\s*${v}\\s*\\}\\}`, 'g');
    const value = variables[v] ?? `{{${v}}}`;
    output = output.replace(placeholderRegex, value);
  });
  return output;
};
